import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    callback: PropTypes.func.isRequired,
    active: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
};

const defaultProps = {
    active: false,
    label: '',
};

/*
 * Component
 */
function Switch({
    callback,
    active,
    label,
    name
}) {
    return (
        <label htmlFor={name} className="switch">
            {label}
            <input
                id={name}
                type="checkbox"
                checked={active}
                onChange={callback}
            />
            <span className="switch-slider" />
        </label>
    );
}

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;

export default Switch;
